module.exports = __webpack_public_path__ + "img/relif.102af25a.svg";